import { Link } from 'react-router-dom';
import { Anchor, Box, Card, CardBody, Heading, Page, PageContent, Paragraph, Text } from 'grommet';

import { groupedDocs } from '../docs/manifest';
import { CONTACT_EMAIL, LEGACY_DOCS_URL, YOUTUBE_CHANNEL_URL } from '../config';

export default function DocsIndex() {
  return (
    <Page kind="narrow" pad="medium">
      <PageContent>
        <Heading level={1} size="small" margin={{ bottom: 'xsmall' }}>League docs</Heading>
        <Paragraph fill margin={{ top: 'none' }}>
          Rules, format and season recaps for the Fantasy Pals Elimination League.
        </Paragraph>

        {groupedDocs().map(({ name, docs }) => (
          <Box key={name} margin={{ top: 'medium' }} gap="small" flex={false}>
            <Text size="small" weight="bold" color="dark-3">{name.toUpperCase()}</Text>
            {docs.map((doc) => (
              <Card key={doc.slug} flex={false}>
                <CardBody pad="medium">
                  <Anchor as={Link} to={`/docs/${doc.slug}`} size="large" weight="bold">
                    {doc.title}
                  </Anchor>
                  <Paragraph fill size="small" margin={{ top: 'xsmall', bottom: 'none' }}>
                    {doc.summary}
                  </Paragraph>
                </CardBody>
              </Card>
            ))}
          </Box>
        ))}

        <Box
          margin={{ top: 'large' }}
          pad={{ top: 'medium' }}
          border={{ side: 'top', color: 'light-4' }}
          gap="xsmall"
          flex={false}
        >
          <Text size="small">
            Watch on{' '}
            <Anchor href={YOUTUBE_CHANNEL_URL} target="_blank" rel="noreferrer noopener">YouTube</Anchor>
            {' · '}
            Questions? <Anchor href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Anchor>
          </Text>
          <Text size="xsmall" color="dark-3">
            These pages replace the old{' '}
            <Anchor
              size="xsmall"
              href={LEGACY_DOCS_URL}
              target="_blank"
              rel="noreferrer noopener"
            >
              Notion page
            </Anchor>.
          </Text>
        </Box>
      </PageContent>
    </Page>
  );
}
